// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cookie-border[data-v-efaf6678]{border:1px solid #ececec;position:fixed;right:40px;bottom:40px;z-index:99999!important;background:#fff}@media screen and (max-width:464px){.cookie-border[data-v-efaf6678]{right:0;left:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
